import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import DashboardFilters from './DashboardFilters';

const DetailedPageLayout = ({ title, children, onFilterChange, filters, showCategoryFilter, categoryLabel, categories, isSubView = false }) => {
    const navigate = useNavigate();

    const handleFilterChange = (newFilters) => {
        if (onFilterChange) onFilterChange(newFilters);
    };

    if (isSubView) {
        return (
            <div className="tab-content pt-4">
                {children}
            </div>
        );
    }

    return (
        <div className="dashboard-container">
            <div className="dashboard-content">
                {/* Sticky Header Wrapper */}
                <div className="detailed-page-header-sticky">
                    <div className="dashboard-header-mini">
                        <div className="flex items-center gap-4">
                            <button
                                onClick={() => navigate(-1)}
                                className="p-2 hover:bg-white/20 rounded-xl transition-colors text-white group"
                                title="Back to Dashboard"
                            >
                                <ArrowLeft size={24} className="group-hover:-translate-x-1 transition-transform" />
                            </button>
                            <div>
                                <h1 className="text-xl md:text-2xl font-bold text-white leading-tight">{title}</h1>
                                <p className="text-xs md:text-sm text-indigo-100 opacity-90">Detailed statistics and analytics</p>
                            </div>
                        </div>
                    </div>

                    <div className="mt-4 pb-2 border-b border-gray-100/50">
                        <DashboardFilters
                            currentFilters={filters}
                            onFilterChange={handleFilterChange}
                            showCategoryFilter={showCategoryFilter}
                            categoryLabel={categoryLabel}
                            categories={categories}
                        />
                    </div>
                </div>

                {/* Content area */}
                <div className="tab-content pt-4">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default DetailedPageLayout;
